export default function ErrorBanner({ message, onDismiss }) {
  return (
    <div className="w-full rounded-xl bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-200 p-4 text-lg flex items-center justify-between gap-4">
      <span className="flex-1">{message}</span>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="flex-shrink-0 w-8 h-8 rounded-full hover:bg-red-200 dark:hover:bg-red-800/50 flex items-center justify-center transition-colors"
          aria-label="Dismiss error"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}
    </div>
  );
}
